module.exports = __webpack_public_path__ + "img/logo.7cfb689a.png";